import $ from "jquery";
import debounce from "debounce";

const submit = () => {
  $(".data-hub-table-container .card-container .card").addClass("reloading");

  if ($("#search_object_current_search_id").val()) {
    $("#search_object_current_search_id").trigger("change");
  } else {
    $("#edit_search_object").submit();
  }
};
const tfs = (n) => {
  debounce(submit, n || 1000)();
};
const HackyAjaxyStuff = {
  triggerFormSubmit: tfs
};

export default HackyAjaxyStuff;
